import { useNewInBoxConditions } from "../../hooks/useNewInBoxConditions";
import GreyBox from "../nonFunctionalComponents/greyBox/GreyBox";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./NewInBox.scss";

const NewInBox = () => {
  const shouldShow = useNewInBoxConditions();
  const { getTranslation } = useRuntimeConstants();

  if (!shouldShow) {
    return null;
  }

  return (
    <GreyBox>
      <p className={styles.newInBoxText}>
        <span className={styles.newInBoxTitle}>
          {getTranslation("ea_new_in_pdp_banner_title")}
        </span>{" "}
        <span className={styles.newInBoxDescription}>
          {getTranslation("ea_new_in_pdp_banner_body")}
        </span>
      </p>
    </GreyBox>
  );
};

export default NewInBox;
